module.exports = __webpack_public_path__ + "static/img/img-bottom.a8134c6.jpg";